// Services
import { get } from "lodash";
import callAPI from "../callApi";
import path from "../variables";

const Reports = {
	getReceiptReportByUserVehicle: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/transactions/receipts/user-vehicle${filter ? filter : ""}`,
			"",
			"getting receipt report by user and vehicle stats"
		),
	getReceiptReportBySource: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/transactions/receipts/source${filter ? filter : ""}`,
			"",
			"getting receipt report by source"
		),
	getSummarizedExpensesByPeriod: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/report/general-expenses/summary-by-period${filter ? filter : ""}`,
			"",
			"getting summarized expenses by period"
		),
	getSummarizedExpensesTicketSalesByPeriod: (filter: any) =>
		callAPI(
			"GET",
			`${path.base}/report/expenses/summary-activity-by-period${filter ? filter : ""}`,
			"",
			"getting summarized ticket sales expenses by period"
		),
};

export default Reports;
